import axios from 'axios';
import { store } from '../../redux/store';
import { generateDeviceId } from '../../helpers/common';
import {
  beginMutation,
  clearInFlightRequest,
  endMutation,
  getInFlightRequest,
  getRequestKey,
  isMutationMethod,
  setInFlightRequest,
} from '../../helpers/mutationLock';
import _ from 'lodash';
const axiosInstance = axios.create();

const withoutTokenEndpoints = [
  'api/auth/customers/sign_in',
  'api/auth/customers.json',
  'api/auth/users/forgot_password',
  'api/auth/users/change_password',
  'api/auth/users/connect_with_facebook',
  'api2/dashboard/eclub_guests',
  'api2/dashboard/locations',
  'api2/dashboard/eclub_guests'
];
axiosInstance.interceptors.request.use(
  (config: any) => {
    try {

      const url = config?.url || '';

      let isPunchhApi = url?.toString().includes('punchh_api');
      if (isPunchhApi && config.headers) {
        let endpoint: any = url?.toString().split('punchh_api/');
        endpoint = endpoint[1];
        const filteredEndPoints = withoutTokenEndpoints.filter((item) => endpoint.startsWith(item))
        if (_.isEmpty(filteredEndPoints)) {
          config.headers['Authorization'] = `Bearer ${store.getState().providerReducer.providerToken.access_token
            }`;
        }
        const deviceId: string = store.getState().authReducer.deviceId
          ? store.getState().authReducer.deviceId
          : generateDeviceId();
        if (deviceId) {
          config.headers['punchh-app-device-id'] = deviceId;
        }
      }

      if (isMutationMethod(config.method)) {
        const key = getRequestKey(config);
        const existing = getInFlightRequest(key);
        const defaultAdapter = axios.getAdapter(axios.defaults.adapter);
        beginMutation();

        if (existing) {
          config.adapter = () =>
            existing.finally(() => {
              endMutation();
            });
          return config;
        }

        let resolveRequest: (value: unknown) => void;
        let rejectRequest: (reason?: unknown) => void;
        const deferred = new Promise((resolve, reject) => {
          resolveRequest = resolve;
          rejectRequest = reject;
        });
        // Duplicate callers may never attach, so mark rejections handled.
        deferred.catch(() => {});
        setInFlightRequest(key, deferred);

        config.adapter = async (cfg: any) => {
          try {
            const result = await defaultAdapter(cfg);
            resolveRequest(result);
            return result;
          } catch (error) {
            rejectRequest(error);
            throw error;
          } finally {
            clearInFlightRequest(key);
            endMutation();
          }
        };
      }

      return config;
    } catch (e: any) {
      throw e;
    }
  },
  function (error: any) {
    return Promise.reject(error);
  },
);

export default axiosInstance;
